import React, {Component} from "react";
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    Button,
    Input,
    Label
} from "reactstrap";
import Phone from "react-phone-number-input";

import Registry from "../Utils/Registry";
import Helpers from "../Utils/Helpers";
import {NotificationManager} from "react-notifications";
import { InitiateLogin } from "@TaankYou/auth";


class Login extends Component {
    constructor(props){
        super(props);

        this.api = Registry.registered("api");

        this.postUpdates = this.postUpdates.bind(this);
        this.inputChanged = this.inputChanged.bind(this);

        this.token = this.props.match.params.token;

        this.state = {
            success: false,
            loading: false,
            token_validated: false,
            business: {name: ""},
            fields: {
                first_name: "",
                last_name: "",
                email: "",
                phone_number: "",
                pass: "",
                pass_confirm: ""
            },
            fields_error: {
                first_name: false,
                last_name: false,
                email: false,
                phone_number: false,
                pass: false,
                pass_confirm: false
            }
        };
    }

    componentDidMount(){
        if(this.token){
            this.setState({
                loading: true,
                token_validated: false
            });

            this.api.get("/business/coworkers/checkToken?token=" + this.token)
                .then((results) => {
                    let fields = this.state.fields;
                    fields.first_name = results.customer.first_name;
                    fields.last_name = results.customer.last_name;
                    fields.email = results.customer.email;

                    this.setState({
                        loading: false,
                        token_validated: true,
                        business: {name: results.customer.business_name},
                        fields: fields
                    });
                })
                .catch(error => {
                    this.setState({loading: false}, () => {
                        NotificationManager.error("Invitation introuvable. Il se peut que le client soit déjà actif.");
                    });
                });
        }
        else{
            this.setState({loading: false}, () => {
                NotificationManager.error("Invitation introuvable")
            });
        }
    }

    postUpdates(){
        if(this.token){
            let errors = Helpers.checkFieldErrors([
                "first_name",
                "last_name",
                "email",
                "phone_number",
                "pass",
                "pass_confirm"
            ], this.state.fields);
            let fields_error = errors.fields;
            if(this.state.fields.pass.length < 6 || this.state.fields.pass !== this.state.fields.pass_confirm){
                fields_error.pass = true;
                fields_error.pass_confirm = true;
            }
            this.setState({fields_error: fields_error});

            if(!fields_error.pass){
                this.setState({
                    loading: true,
                    success: false
                });

                this.api.put("/business/coworkers/activate?token=" + this.token, {
                    first_name: this.state.fields.first_name,
                    last_name: this.state.fields.last_name,
                    email: this.state.fields.email,
                    password: this.state.fields.pass,
                    phone_number: this.state.fields.phone_number
                })
                .then(() => {
                    this.setState({
                        loading: false,
                        success: true
                    }, () => {
                        NotificationManager.success("Votre compte a bien été validé. Vous allez etre redirigé vers votre compte d'ici quelques secondes.")
                    });

                    setTimeout(() => InitiateLogin(), 4000);
                })
                .catch(error => {
                    let details = "";
                    if(error.hasOwnProperty("subcode")){
                        switch(error.subcode){
                            case "PUTBusinessEmailExists":
                            case "PUTBusinessCoworkersEmailExists":
                                details = "Cette adresse email est déjà utilisée.";
                                break;
                            case "PUTBusinessInvalidPassword":
                            case "PUTBusinessCoworkersInvalidPassword":
								details = "Votre mot de passe doit contenir au moins 6 caractères et etre composé d'au minimun un chiffre, une minuscule et une majuscule.";
                                break;
                            case "PUTBusinessInvalidPhoneNumber":
                            case "PUTBusinessCoworkersInvalidPhoneNumber":
                                details = "Le numéro de téléphone n'est pas correct.";
                                break;
                        }
                    }

                    this.setState({loading: false}, () => {
                        NotificationManager.error("Impossible d'activer votre compte. " + details);
                    });
                })
            }
        }
        else
            NotificationManager.error("Erreur de token");
    }

    inputChanged(e, input_key){
        if(this.state.fields.hasOwnProperty(input_key) && typeof e !== "undefined"){
            let nState = {...this.state};
            nState.fields[input_key] = (typeof e === "string" ? e : e.target.value);
            nState.fields_error[input_key] = false;
            this.setState(nState);
        }
    }

    render() {
        return (
            <div className="app align-items-center bg-blue_dark">

                <div className="wp-100 text-center display-block marg-t-50 marg-b-100">
                    <img src="../img/TankYou-v2-white.png" className="img-fluid _w-200" />
                </div>

                <Container className="display-block">
                    <Row className="justify-content-center">
                        <h1 className="ty-title-blue_dark ty-title-after-blue text-white">Cr&eacute;er votre compte</h1>
                    </Row>
                    <Row className="justify-content-center">
                        <Col md="6">
                            {
                                this.state.loading ?
                                    <div className="center">
                                        <i className="icon icon-loading animated spin infinite white f-30"> </i>
                                    </div>
                                    :
                                    this.state.token_validated && !this.state.success ?
                                        <Card className="p-4 border-rad-5">
                                            <CardBody className="card-body">
                                                <Row className="marg-b-10">
                                                    <Col md="12">
                                                        <Label className="bold text-uppercase">Soci&eacute;t&eacute;</Label>
                                                        <Input
                                                            type="text"
                                                            value={this.state.business.name}
                                                            className={"wp-100"}
                                                            readOnly
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row className="marg-b-10">
                                                    <Col md="6">
                                                        <Label className="bold text-uppercase">Pr&eacute;nom</Label>
                                                        <Input
                                                            type="text"
                                                            className={"wp-100" + (this.state.fields_error.first_name ? " error" : "")}
                                                            value={this.state.fields.first_name}
                                                            onChange={e => {this.inputChanged(e, "first_name")}}
                                                            required
                                                        />
                                                    </Col>
                                                    <Col md="6">
                                                        <Label  className="bold text-uppercase">Nom</Label>
                                                        <Input
                                                            className={"wp-100" + (this.state.fields_error.last_name ? " error" : "")}
                                                            value={this.state.fields.last_name}
                                                            onChange={e => {this.inputChanged(e, "last_name")}}
                                                            required
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row className="marg-b-10">
                                                    <Col md="12">
                                                        <Label className="bold text-uppercase">Email</Label>
                                                        <Input
                                                            type="text"
                                                            value={this.state.fields.email}
                                                            onChange={e => {this.inputChanged(e, "email")}}
                                                            className={"wp-100" + (this.state.fields_error.email ? " error" : "")}
                                                            required
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row className="marg-b-10">
                                                    <Col md="12">
                                                        <Label className="bold marg-b-0">
                                                            <Label className="bold">
                                                                <span className="text-uppercase">Mot de passe</span>
                                                                <span className="font-xs gray marg-l-10">(minimum 6 charact&egrave;res)</span>
                                                            </Label>
                                                        </Label>
                                                        <Input
                                                            type="password"
                                                            value={this.state.fields.pass}
                                                            onChange={e => {this.inputChanged(e, "pass")}}
                                                            className={"wp-100" + (this.state.fields_error.pass ? " error" : "")}
                                                            required
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row className="marg-b-10">
                                                    <Col md="12">
                                                        <Label className="bold text-uppercase">Confirmation</Label>
                                                        <Input
                                                            type="password"
                                                            value={this.state.fields.pass_confirm}
                                                            onChange={e => {this.inputChanged(e, "pass_confirm")}}
                                                            className={"wp-100" + (this.state.fields_error.pass_confirm ? " error" : "")}
                                                            required
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row className="marg-t-10 marg-b-10">
                                                    <Col md="12">
                                                        <Label className="bold text-uppercase">Téléphone</Label>
                                                        <Phone
                                                            country={'FR'}
                                                            onChange={e => this.inputChanged(e, "phone_number")}
                                                            value={this.state.fields.phone_number}
                                                            className={"wp-100 form-control" + (this.state.fields_error.phone_number ? " error" : "")}
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row className="marg-t-40">
                                                    <Col xs="12" className="center">
                                                        <Button color="primary" className="px-4" onClick={this.postUpdates}>Valider</Button>
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                        :
                                        ""
                            }
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}

export default Login;



// WEBPACK FOOTER //
// ./src/pages/Creation.js